export type FAQTopic =
  | "general"
  | "payments"
  | "account"
  | "security"
  | "technical";

export type FAQItem = {
  id: string;
  questionKey: string;
  answerKey: string;
  topic: FAQTopic;
  tags: string[];
};

export const faqItems: FAQItem[] = [
  {
    id: "util-portal-what",
    questionKey: "faq.whatIsPortalQ",
    answerKey: "faq.whatIsPortalA",
    topic: "general",
    tags: ["portal"],
  },
  {
    id: "privacy-policy",
    questionKey: "faq.privacyPolicyQ",
    answerKey: "faq.privacyPolicyA",
    topic: "security",
    tags: ["privacy"],
  },
  {
    id: "browser-support",
    questionKey: "faq.browserQ",
    answerKey: "faq.browserA",
    topic: "technical",
    tags: ["browser"],
  },
  {
    id: "registration",
    questionKey: "faq.registerQ",
    answerKey: "faq.registerA",
    topic: "account",
    tags: ["registration"],
  },
  {
    id: "registration-info",
    questionKey: "faq.registrationInfoQ",
    answerKey: "faq.registrationInfoA",
    topic: "account",
    tags: ["registration"],
  },
  {
    id: "payment-methods",
    questionKey: "faq.paymentMethodsQ",
    answerKey: "faq.paymentMethodsA",
    topic: "payments",
    tags: ["payment"],
  },
  {
    id: "billing-cycle",
    questionKey: "faq.billingFrequencyQ",
    answerKey: "faq.billingFrequencyA",
    topic: "payments",
    tags: ["billing"],
  },
  {
    id: "bill-payment",
    questionKey: "faq.payOnlineQ",
    answerKey: "faq.payOnlineA",
    topic: "payments",
    tags: ["payment"],
  },
  {
    id: "account-security",
    questionKey: "faq.accountProtectionQ",
    answerKey: "faq.accountProtectionA",
    topic: "security",
    tags: ["security"],
  },
];

export const topicLabelKeys: Record<FAQTopic | "all", string> = {
  all: "faq.allQuestions",
  general: "faq.generalQuestions",
  payments: "faq.paymentsBilling",
  account: "faq.accountManagement",
  security: "faq.securityPrivacy",
  technical: "faq.technicalSupport",
};

export const topics: (FAQTopic | "all")[] = Object.keys(topicLabelKeys) as (
  | FAQTopic
  | "all"
)[];
